
export default [
    {
        path: 'basic',
        component: resolve => require(['@/views/basic'], resolve),
        name: 'Basic',
        keepAlive: true,
        meta: {
            nav: '基础能力平台'
        }
    }
      
]


// WEBPACK FOOTER //
// ./src/router/basic.js